import {
  useConversationAddedEvent,
  useConversationRemovedEvent,
  useConversationUpdatesEvent,
  useMessageDeletionEvents,
  useMessageDeliveryAck,
  useMessagePinnedEvent,
  useMessageReactionUpdatedEvent,
  useMessageReceiveEvent
} from '@/core/realtime';

export const useSocketEventHandlers = () => {
  useMessageReceiveEvent();
  useConversationUpdatesEvent();
  useConversationAddedEvent();
  useConversationRemovedEvent();
  useMessageDeletionEvents();
  useMessagePinnedEvent();
  useMessageReactionUpdatedEvent();
  useMessageDeliveryAck();
};
